export default __webpack_public_path__ + "static/media/info-fill.dc596c8a.svg";